import { ProviderRow, ProviderType, SentRow } from "namirasoft-telegram-sender";
import { IEntityInfo, NSARouterMakerResult } from "namirasoft-account-react";
import { TelegramSenderRoutes } from "./TelegramSenderRoutes";
import { ProductUUID } from "namirasoft-api-product";
import { TelegramSenderMenus } from "./TelegramSenderMenus";
import { TelegramSenderRouterProps } from "./TelegramSenderRouterProps";
import { BaseColumnFormatter, BooleanFormatter, DateTimeFormatter, EnumFormatter, ForeColorFormatter, IDFormatter, IntegerFormatter, JsonFormatter, StringFormatter, StringFormatterSizeType } from "namirasoft-site-react";
import { NamirasoftMap } from "namirasoft-site-map";
import { IStorageLocal } from "namirasoft-core";

export class TelegramSenderEntities
{
	static provider(props: NSARouterMakerResult & TelegramSenderRouterProps): IEntityInfo<ProviderRow, ProviderRow>
	{
		let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

		return {
			product_id: ProductUUID.NAMIRASOFT_TELEGRAM_SENDER,
			name: "provider",
			tables: [{ table: namirasoft.telegram_sender.tables.provider, required: true }],
			client: {
				getListURL: () => TelegramSenderRoutes.ProviderList,
				getNewURL: () => TelegramSenderRoutes.ProviderNew,
				getCopyURL: (id: string) => TelegramSenderRoutes.ProviderCopy(id),
				getEditURL: (id: string) => TelegramSenderRoutes.ProviderEdit(id),
				getViewURL: (id: string) => TelegramSenderRoutes.ProviderView(id),
				getColumns: () =>
				{
					return [
						BaseColumnFormatter.getColumn(namirasoft.telegram_sender.tables.provider.columns.id, new IDFormatter(namirasoft, null)),
						BaseColumnFormatter.getColumn(namirasoft.telegram_sender.tables.provider.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.telegram_sender.tables.provider.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.telegram_sender.tables.provider.columns.name, new StringFormatter(StringFormatterSizeType.FullName)),
						BaseColumnFormatter.getColumn(namirasoft.telegram_sender.tables.provider.columns.type, new EnumFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.telegram_sender.tables.provider.columns.e_verified, new ForeColorFormatter(new BooleanFormatter("Verified", "Not Yet"), { true: "green", false: "red" })),
						BaseColumnFormatter.getColumn(namirasoft.telegram_sender.tables.provider.columns.meta, new JsonFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.telegram_sender.tables.provider.columns.limit, new BooleanFormatter("Yes", "No")),
						BaseColumnFormatter.getColumn(namirasoft.telegram_sender.tables.provider.columns.limit_count, new IntegerFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.telegram_sender.tables.provider.columns.limit_per_value, new IntegerFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.telegram_sender.tables.provider.columns.limit_per_unit, new StringFormatter(StringFormatterSizeType.Word)),
						BaseColumnFormatter.getColumn(namirasoft.telegram_sender.tables.provider.columns.delay, new BooleanFormatter("Yes", "No")),
						BaseColumnFormatter.getColumn(namirasoft.telegram_sender.tables.provider.columns.delay_value, new IntegerFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.telegram_sender.tables.provider.columns.delay_unit, new StringFormatter(StringFormatterSizeType.Word)),
						BaseColumnFormatter.getColumn(namirasoft.telegram_sender.tables.provider.columns.description, new StringFormatter(StringFormatterSizeType.Description)),
						BaseColumnFormatter.getColumn(namirasoft.telegram_sender.tables.provider.columns.created_at, new DateTimeFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.telegram_sender.tables.provider.columns.updated_at, new DateTimeFormatter()),
					];
				},
				onCreate: async (entity) =>
				{
					let body = { ...entity, ...entity.meta };
					delete body.id;
					delete body.user_id;
					delete body.project_id;
					delete body.type;
					delete body.e_verified;
					delete body.meta;
					delete body.created_at
					delete body.updated_at;
					if (entity.type === ProviderType.NamirasoftBot)
						return await props.servers.telegram_sender.namirasoft_bot.Create(body);
					if (entity.type === ProviderType.CustomBot)
						return await props.servers.telegram_sender.custom_bot.Create(body);
					throw new Error("Wrong provider type");
				},
				onUpdate: async (id, entity) =>
				{
					let body = { ...entity, ...entity.meta };
					delete body.id;
					delete body.user_id;
					delete body.project_id;
					delete body.type;
					delete body.e_verified;
					delete body.meta;
					delete body.created_at
					delete body.updated_at;
					if (entity.type === ProviderType.NamirasoftBot)
						return await props.servers.telegram_sender.namirasoft_bot.Update(id, body);
					if (entity.type === ProviderType.CustomBot)
						return await props.servers.telegram_sender.custom_bot.Update(id, body);
					throw new Error("Wrong provider type");
				},
				getMenus: (getIDs, getRows) => { return { "Provider": [TelegramSenderMenus.verify(getIDs, getRows), TelegramSenderMenus.send(getIDs, getRows)] } },
				onSuccess: (entity) =>
				{
					props.url.redirect(TelegramSenderRoutes.Verify(entity.id), {});
					return true;
				}
			},
			server: {
				value_list: props.servers.telegram_sender.value.List,
				get: props.servers.telegram_sender.provider.Get,
				list: props.servers.telegram_sender.provider.List,
				create: async (entity) =>
				{
					if (entity.type === ProviderType.NamirasoftBot)
					{
						let body = {
							workspace_id: entity.workspace_id,
							name: entity.name,
							chat_id: entity.meta.chat_id,
							message_thread_id: entity.meta.message_thread_id,
							limit: entity.limit,
							limit_count: entity.limit_count,
							limit_per_value: entity.limit_per_value,
							limit_per_unit: entity.limit_per_unit,
							delay: entity.delay,
							delay_value: entity.delay_value,
							delay_unit: entity.delay_unit,
							description: entity.description,
							provider_category: [], provider_field: [], provider_tag: [],
						};
						return await props.servers.telegram_sender.namirasoft_bot.Create(body);
					}
					if (entity.type === ProviderType.CustomBot)
					{
						let body = {
							workspace_id: entity.workspace_id,
							name: entity.name,
							chat_id: entity.meta.chat_id,
							message_thread_id: entity.meta.message_thread_id,
							api_token: entity.meta.api_token,
							limit: entity.limit,
							limit_count: entity.limit_count,
							limit_per_value: entity.limit_per_value,
							limit_per_unit: entity.limit_per_unit,
							delay: entity.delay,
							delay_value: entity.delay_value,
							delay_unit: entity.delay_unit,
							description: entity.description,
							provider_category: [], provider_field: [], provider_tag: [],
						};
						return await props.servers.telegram_sender.custom_bot.Create(body);
					}
					throw new Error("Wrong provider type");
				},
				update: async (id, entity) =>
				{
					if (entity.type === ProviderType.NamirasoftBot)
					{
						let body = {
							workspace_id: entity.workspace_id,
							name: entity.name,
							chat_id: entity.meta.chat_id,
							message_thread_id: entity.meta.message_thread_id,
							limit: entity.limit,
							limit_count: entity.limit_count,
							limit_per_value: entity.limit_per_value,
							limit_per_unit: entity.limit_per_unit,
							delay: entity.delay,
							delay_value: entity.delay_value,
							delay_unit: entity.delay_unit,
							description: entity.description,
							provider_category: [], provider_field: [], provider_tag: [],
						};
						return await props.servers.telegram_sender.namirasoft_bot.Update(id, body);
					}
					if (entity.type === ProviderType.CustomBot)
					{
						let body = {
							workspace_id: entity.workspace_id,
							name: entity.name,
							chat_id: entity.meta.chat_id,
							message_thread_id: entity.meta.message_thread_id,
							api_token: entity.meta.api_token,
							limit: entity.limit,
							limit_count: entity.limit_count,
							limit_per_value: entity.limit_per_value,
							limit_per_unit: entity.limit_per_unit,
							delay: entity.delay,
							delay_value: entity.delay_value,
							delay_unit: entity.delay_unit,
							description: entity.description,
							provider_category: [], provider_field: [], provider_tag: [],
						};
						return await props.servers.telegram_sender.custom_bot.Update(id, body);
					}
					throw new Error("Wrong provider type");
				},
				delete: props.servers.telegram_sender.provider.Delete,
			}
		};
	}
	static sent(props: NSARouterMakerResult & TelegramSenderRouterProps): IEntityInfo<SentRow, SentRow>
	{
		let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

		return {
			product_id: ProductUUID.NAMIRASOFT_TELEGRAM_SENDER,
			name: "sent",
			tables: [{ table: namirasoft.telegram_sender.tables.sent, required: true }],
			client: {
				getListURL: () => TelegramSenderRoutes.SentList,
				getNewURL: null,
				getCopyURL: null,
				getEditURL: null,
				getViewURL: null,
				getColumns: () =>
				{
					return [
						BaseColumnFormatter.getColumn(namirasoft.telegram_sender.tables.sent.columns.id, new IDFormatter(namirasoft, null)),
						BaseColumnFormatter.getColumn(namirasoft.telegram_sender.tables.sent.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.telegram_sender.tables.sent.columns.session_id, new IDFormatter(namirasoft, null)),
						BaseColumnFormatter.getColumn(namirasoft.telegram_sender.tables.sent.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.telegram_sender.tables.sent.columns.provider_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.telegram_sender.tables.sent.columns.chat_id, new StringFormatter(StringFormatterSizeType.TwoWords)),
						BaseColumnFormatter.getColumn(namirasoft.telegram_sender.tables.sent.columns.message_thread_id, new StringFormatter(StringFormatterSizeType.TwoWords)),
						BaseColumnFormatter.getColumn(namirasoft.telegram_sender.tables.sent.columns.message, new StringFormatter(StringFormatterSizeType.Description)),
						BaseColumnFormatter.getColumn(namirasoft.telegram_sender.tables.sent.columns.successful, new ForeColorFormatter(new BooleanFormatter("Successful", "Failed"), { true: "green", false: "red" })),
						BaseColumnFormatter.getColumn(namirasoft.telegram_sender.tables.sent.columns.result, new StringFormatter(StringFormatterSizeType.Sentence)),
						BaseColumnFormatter.getColumn(namirasoft.telegram_sender.tables.sent.columns.created_at, new DateTimeFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.telegram_sender.tables.sent.columns.sent_at, new DateTimeFormatter()),
					];
				}
			},
			server: {
				value_list: props.servers.telegram_sender.value.List,
				get: props.servers.telegram_sender.sent.Get,
				list: props.servers.telegram_sender.sent.List,
				create: null,
				update: null,
				delete: null,
			}
		}
	}
}